<template>
  <!-- 短链接生成工具 -->
  <div class="page-container">
    <!-- 表单卡片 -->
    <div class="page-card">
      <div class="page-card__body">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item
            prop="path"
            label="path："
            style="margin-top: 20px"
          >
            <el-input
              placeholder="填入地址"
              v-model="form.path"
            ></el-input>
          </el-form-item>
          <el-form-item prop="query" label="query：" style="margin-top: 20px">
            <el-input
              placeholder="请输入"
              v-model="form.query"
            ></el-input>
          </el-form-item>
          <!-- 提示信息 -->
          <div style="margin: 0 0 20px 0;font-size: 14px;color: #999999;">
            <span>苏州展页面</span><br>
            <span>path：pages/tradeshow/index</span><br>
            <span>query：tab=0</span>
          </div>
          <el-row style="margin-top: 30px; text-align: center">
            <el-button
              @click="onSubmit('form')"
              type="primary"
            >
              获取
            </el-button>
          </el-row>
        </el-form>
      </div>
    </div>

    <!-- 链接信息弹窗 -->
    <el-dialog
      title="链接信息"
      :visible.sync="dialogVisible"
      :before-close="handleClose">
      <div style="padding: 20px;text-align: left;font-weight: bold;">{{path}}</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "ShortLink",
  data() {
    return {
      path: '',
      query: '',
      dialogVisible: false,
      form: {
        path: "",
        query: "",
      },
      rules: {
        path: [
          {required: true, message: "请填写path", trigger: "blur"},
        ],
      }
    }
  },
  methods: {
    // 提交表单获取短链接
    onSubmit(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let url = this.baseUrl + "/admin/get_short_url/";
          api
            .postData(url, {
              path: this.form.path,
              query: this.form.query,
            })
            .then((res) => {
              this.path = res;
              this.dialogVisible = true;
            })
            .catch((error) => {
              this.$message({
                message: error.response.data,
                type: "error",
              });
            });
        }
      });
    },
    // 关闭弹窗确认
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {
        });
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/ShortLink.vue